import { Lesson } from "@jelly/lesson";
import principle01 from "./layouts/principle-01/principle";
import principle02 from "./layouts/principle-02/principle";
import principle03 from "./layouts/principle-03/principle";
import principle04 from "./layouts/principle-04/principle";
import principle05 from "./layouts/principle-05/principle";
import principle06 from "./layouts/principle-06/principle";
import principle07 from "./layouts/principle-07/principle";
import principle08 from "./layouts/principle-08/principle";

const lesson: Lesson = {
  id: "0305f321-8f36-411d-8400-cecd0e4b2a24",
  publicId: "32",
  name: "Car simulator (Binaural TP Synthesis)",
  difficulty: 2,
  contentTypes: { audio: true, interactive: true, video: false },
  showHeaderNavigation: true,

  body: [principle01, principle02, principle03, principle04, principle05, principle06, principle07, principle08],
};

export default lesson;
